import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function TilesSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  const media = display.permissions.canViewContent && !display.access.isContentLocked
    ? display.media.primaryAttachment
    : undefined
  const mediaSrc = media?.src || media?.thumbSrc
  return (
    <>
      <div className={`md-subs-tiles-row relative m-0 inline-flex h-[200px] min-w-[150px] max-w-[400px] flex-[1_1_200px] flex-col overflow-hidden bg-[#1a1a1a] p-3 text-xs text-white hover:opacity-85${display.isChecked ? ' md-subs-tiles-row--checked bg-[#333]' : ''}`}>
        {mediaSrc ? <img className="absolute inset-0 h-full w-full object-cover opacity-55" src={mediaSrc} alt={media.title || media.filename || display.title} /> : null}
        <div className="md-subs-tiles-title z-[1] min-w-0 overflow-hidden text-ellipsis whitespace-nowrap font-semibold [&_.md-sub-title-link]:text-white">{controls.content.title}</div>
        <div className="md-subs-tiles-text z-[1] mt-2 min-h-0 flex-1 overflow-hidden leading-[1.35] text-white/80 [&_.md-sub-text]:whitespace-normal [&_.md-sub-text]:text-white/80">{controls.content.text}</div>
        <div className="md-subs-tiles-meta z-[1] mt-2 flex items-center justify-between text-white/70">
          {controls.content.time}
          <span className="flex gap-2">{controls.actions.check}{controls.actions.favorite}{controls.actions.quickReply}</span>
        </div>
      </div>
      {slots.allChildren}
    </>
  )
}
